import { useRef } from 'react';
import Stack from '@mui/material/Stack';
import { DetailView } from './detail-view';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import BackNavigation from 'src/components/ui/headers/title-back';
import PageSection from 'src/layouts/page-section';
import { nextNavigate } from 'src/utils/navigation-utils';
import { paths } from 'src/paths';
import { useRouter } from 'src/hooks/use-router';
import useDeviceView from 'src/hooks/use-device-view';
import useForms from 'src/api/courses/vm-form';
import useToast from 'src/utils/toast-utils';

const Page = ({ onNavigate, item, usePers }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const router = useRouter();
  const childRef = useRef();
  const { useCompactLayout } = useDeviceView();
  
  const { unassignStudent } = useForms();
  const { toastSuccess, toastError } = useToast();
  
  const handleAccountDetail = (account) => {
    nextNavigate(
      router,
      { id: item.id },
      paths.students.details,
      paths.courses.details,
      { id: account.id, code: account.code, to: 'course' },
    );
  };

  const handleAssignClick = (item) => {
    nextNavigate(
      router,
      { id: item.id },
      paths.courses.student,
      paths.courses.details,
      { id: item.id, name: item.name },
    );
  };

  const handleRemoveClick = async (args) => {
    const params = {courseId: item.id, studentId: args.id};
    await unassignStudent(params,
      (result) => {
        const msg = `${args.name} đã được bỏ khỏi khóa`;
        toastSuccess(msg);

        childRef.current?.removeItem(result);
      },
      (error) => {
        toastError(error);
      },
    );
  };

  return (
    <PageSection title="Course" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.course)}
        />
        <DetailView 
          ref={childRef} 
          item={item} 
          usePhoneView={useCompactLayout} 
          usePers={usePers}
          handleAccountClick={handleAccountDetail} 
          handleRemoveClick={handleRemoveClick}
          handleAssignClick={handleAssignClick} />
      </Stack>
    </PageSection>
  );
};

export default Page;
